import * as React from 'react'

import RedirectPage from './../component/redirectPage';

const DiagnosticViewPage = () => {
  return <RedirectPage pageRedirectPath="/diagnostics" />;
};

export default DiagnosticViewPage;